import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Users, TrendingUp, ArrowDownCircle, Bell } from 'lucide-react';

const NAV_ITEMS = [
  { to: '/dashboard',    icon: LayoutDashboard, label: 'Home' },
  { to: '/users',        icon: Users,           label: 'Users' },
  { to: '/investments',  icon: TrendingUp,      label: 'Deposits' },
  { to: '/withdrawals',  icon: ArrowDownCircle, label: 'Withdraw' },
  { to: '/notifications',icon: Bell,            label: 'Alerts' },
];

export default function BottomNav() {
  return (
    <nav className="bottom-nav">
      <div className="flex items-center justify-around">
        {NAV_ITEMS.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              `flex flex-col items-center gap-0.5 px-2 py-1 rounded-xl transition-all duration-200 ${
                isActive
                  ? 'text-gold'
                  : 'text-white/45 hover:text-white/70'
              }`
            }
          >
            {({ isActive }) => (
              <>
                <Icon size={20} strokeWidth={isActive ? 2.5 : 1.8} />
                <span className="text-[10px] font-medium tracking-wide">{label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
